import { Link } from "react-router-dom";
import { ShadowMark, Peeker } from "./ShadowMark";
import { useDemoModal } from "./DemoModal";

// Footer shared across every site page (identical markup in the static source).
export default function SiteFooter() {
  const { openDemoModal } = useDemoModal();
  return (
    <footer>
      <div className="wrap">
        <div className="foot">
          <div>
            <Link className="logo" to="/">
              <ShadowMark size={24} />
              Shadow
            </Link>
            <p className="foot-meta">
              The AI coworker for sales teams. One Shadow, a crew underneath, your team's memory at
              the core. Built by Converse AI Inc.
            </p>
          </div>
          <div className="foot-links">
            <div className="col">
              <span className="h">Product</span>
              <Link to="/#product">How Shadow works</Link>
              <Link to="/thoughts#architecture">Architecture</Link>
              <Link to="/agents">Agents directory</Link>
            </div>
            <div className="col">
              <span className="h">Solutions</span>
              <Link to="/solutions#reps">For reps</Link>
              <Link to="/solutions#managers">For managers</Link>
              <Link to="/solutions#cxos">For CXOs</Link>
            </div>
            <div className="col">
              <span className="h">Company</span>
              <Link to="/about">About</Link>
              <Link to="/thoughts">Thoughts</Link>
              <Link to="/security">Security</Link>
              <Link to="/pricing">Pricing</Link>
              <Link to="/changelog">Changelog</Link>
              <a href="https://www.producthunt.com/products/shadow-6" target="_blank" rel="noopener noreferrer">Product Hunt</a>
              <span style={{ color: "var(--ink)", fontWeight: 500, fontSize: "13.5px" }}>hello@shadowlabs.ai</span>
            </div>
            <div className="col">
              <span className="h">Get started</span>
              <button className="demo-link-btn" onClick={() => openDemoModal({ context: "Footer" })}>Book a demo</button>
              <span style={{ color: "var(--gray-4)", fontSize: "12.5px" }}>macOS today, Windows soon</span>
            </div>
          </div>
        </div>
        <div className="foot-bottom peek-host">
          <Peeker style={{ right: "24px", top: "-29px", width: "72px", height: "30px" }} />
          <span>&copy; 2026 Converse AI Inc. All rights reserved.</span>
          <span>
            <Link to="/privacy">Privacy Policy</Link> &middot; <Link to="/terms">Terms of Service</Link> &middot; Shadow is a product of Converse AI Inc.
          </span>
        </div>
      </div>
    </footer>
  );
}
